module.exports = __webpack_public_path__ + "img/Main.038eb213.jpg";